export const COOKIE_DOMAIN = ';domain=.delta.com; path=/';
